'use client';

import React from 'react';
import { useLanguage } from '@/components/language/LanguageProvider';
import type { Language } from '@/lib/i18n';

const OPTIONS: { label: string; value: Language }[] = [
  { label: 'ES', value: 'es' },
  { label: 'EN', value: 'en' },
];

interface LanguageSwitcherProps {
  compact?: boolean;
}

export default function LanguageSwitcher({ compact = false }: LanguageSwitcherProps) {
  const { language, setLanguage, dictionary } = useLanguage();

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/15 bg-black/20 p-1 ${
        compact ? 'gap-0.5' : 'gap-1'
      }`}
      aria-label={dictionary.header.languageLabel}
      role="group"
    >
      {OPTIONS.map((option) => {
        const active = option.value === language;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => setLanguage(option.value)}
            className={`rounded-full px-3 py-1.5 text-[11px] font-bold tracking-[0.08em] transition-colors ${
              active
                ? 'bg-primary text-primary-foreground'
                : 'text-foreground/70 hover:bg-white/10 hover:text-foreground'
            } ${compact ? 'min-w-[44px]' : 'min-w-[48px]'}`}
            aria-pressed={active}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
